(function(){
  function init(root){
    if(!root||root.dataset.vvReady)return;
    root.dataset.vvReady='true';
    var gallery=root.querySelector('[data-vv-gallery]');
    var track=root.querySelector('[data-vv-main-track]');
    var slides=Array.prototype.slice.call(root.querySelectorAll('[data-vv-slide]'));
    var thumbs=Array.prototype.slice.call(root.querySelectorAll('[data-vv-thumb]'));
    var count=root.querySelector('[data-vv-gallery-count]');
    var activeIndex=Math.max(0,thumbs.findIndex(function(item){return item.classList.contains('is-active')}));
    var requestedIndex=activeIndex;
    var galleryRequest=0;
    function normalizeImageIndex(index){return(index+slides.length)%slides.length}
    function getSlideImage(index){var slide=slides[normalizeImageIndex(index)];return slide?slide.querySelector('img'):null}
    function warmImage(index,priority){
      var image=getSlideImage(index);
      if(!image)return Promise.resolve(false);
      image.loading='eager';
      if('fetchPriority' in image)image.fetchPriority=priority?'high':'auto';
      if(image.complete&&image.naturalWidth>0){
        if(typeof image.decode==='function')return image.decode().then(function(){return true}).catch(function(){return true});
        return Promise.resolve(true);
      }
      return new Promise(function(resolve){
        var settled=false;
        var timer=window.setTimeout(function(){finish(image.complete&&image.naturalWidth>0)},12000);
        function cleanup(){window.clearTimeout(timer);image.removeEventListener('load',loaded);image.removeEventListener('error',failed)}
        function finish(ok){if(settled)return;settled=true;cleanup();resolve(!!ok)}
        function loaded(){
          if(typeof image.decode==='function')image.decode().then(function(){finish(true)}).catch(function(){finish(image.naturalWidth>0)});
          else finish(true);
        }
        function failed(){finish(false)}
        image.addEventListener('load',loaded);
        image.addEventListener('error',failed);
      });
    }
    function preloadAdjacent(index){
      if(slides.length<2)return;
      warmImage(index+1,false);
      warmImage(index-1,false);
    }
    function renderImage(index,animate){
      activeIndex=normalizeImageIndex(index);
      requestedIndex=activeIndex;
      track.style.transition='none';
      track.style.transform='none';
      slides.forEach(function(slide,i){slide.classList.toggle('is-active',i===activeIndex)});
      thumbs.forEach(function(thumb,i){
        var selected=i===activeIndex;
        thumb.classList.toggle('is-active',selected);
        thumb.setAttribute('aria-current',selected?'true':'false');
      });
      if(count)count.textContent=(activeIndex+1)+' / '+slides.length;
      if(thumbs[activeIndex])thumbs[activeIndex].scrollIntoView({behavior:animate===false?'auto':'smooth',block:'nearest',inline:'center'});
    }
    function goToImage(index,animate){
      if(!track||!slides.length)return;
      requestedIndex=normalizeImageIndex(index);
      var request=++galleryRequest;
      if(gallery)gallery.classList.remove('has-image-error');
      track.style.transition='none';
      track.style.transform='none';
      warmImage(requestedIndex,true).then(function(loaded){
        if(request!==galleryRequest)return;
        if(!loaded){if(gallery)gallery.classList.add('has-image-error');return}
        renderImage(requestedIndex,animate);
        preloadAdjacent(activeIndex);
      });
    }
    if(track&&slides.length){
      goToImage(activeIndex,false);
      thumbs.forEach(function(button){button.addEventListener('click',function(){goToImage(Number(button.dataset.index)||0,true)})});
      var previous=root.querySelector('[data-vv-gallery-prev]');
      var next=root.querySelector('[data-vv-gallery-next]');
      if(previous)previous.addEventListener('click',function(){goToImage(requestedIndex-1,true)});
      if(next)next.addEventListener('click',function(){goToImage(requestedIndex+1,true)});
      if(gallery){
        gallery.addEventListener('keydown',function(event){
          if(event.key==='ArrowLeft'){event.preventDefault();goToImage(requestedIndex-1,true)}
          if(event.key==='ArrowRight'){event.preventDefault();goToImage(requestedIndex+1,true)}
        });
        gallery.addEventListener('dragstart',function(event){event.preventDefault()});
        var pointerId=null,startX=0,startY=0,deltaX=0;
        gallery.addEventListener('pointerdown',function(event){
          if(event.target.closest('button')||event.button>0)return;
          pointerId=event.pointerId;startX=event.clientX;startY=event.clientY;deltaX=0;
          gallery.classList.add('is-dragging');
          if(gallery.setPointerCapture)gallery.setPointerCapture(pointerId);
        });
        gallery.addEventListener('pointermove',function(event){
          if(pointerId!==event.pointerId)return;
          deltaX=event.clientX-startX;
          var deltaY=event.clientY-startY;
          if(Math.abs(deltaX)>Math.abs(deltaY)){
            event.preventDefault();
          }
        });
        function finishSwipe(event){
          if(pointerId===null||(event&&event.pointerId!==pointerId))return;
          gallery.classList.remove('is-dragging');
          if(Math.abs(deltaX)>45)goToImage(activeIndex+(deltaX<0?1:-1),true);else goToImage(activeIndex,true);
          pointerId=null;deltaX=0;
        }
        gallery.addEventListener('pointerup',finishSwipe);
        gallery.addEventListener('pointercancel',finishSwipe);
      }
    }
    var helpButtons=Array.prototype.slice.call(root.querySelectorAll('.vv-help'));
    var helpPopover=document.createElement('aside');
    helpPopover.className='vv-help-popover';
    helpPopover.setAttribute('role','dialog');
    helpPopover.setAttribute('aria-modal','false');
    helpPopover.hidden=true;
    helpPopover.innerHTML='<button class="vv-help-popover-close" type="button" aria-label="Close information">×</button><div data-vv-help-content></div>';
    document.body.appendChild(helpPopover);
    var activeHelp=null;
    function helpHeading(button){
      var legend=button.closest('legend');
      return legend?legend.textContent.replace('?','').trim():'OPTION INFORMATION';
    }
    function selectedHelpValue(button){
      var fieldset=button.closest('fieldset');
      if(!fieldset)return 'Not selected';
      var other=fieldset.querySelector('[data-vv-top-other]:checked');
      var selected=other||fieldset.querySelector('input[type="radio"]:checked,input[type="checkbox"]:checked');
      return selected?selected.value:'Not selected';
    }
    function nextMeasurementLabels(){
      if(!modal)return '';
      var confirmedOrder=['bust','natural_waist','full_hip','shoulder_width','shoulder_to_cuff','upper_arm','height','inseam'];
      return Array.prototype.slice.call(modal.querySelectorAll('[data-vv-measure][required]')).sort(function(a,b){
        var aIndex=confirmedOrder.indexOf(a.dataset.vvMeasure);
        var bIndex=confirmedOrder.indexOf(b.dataset.vvMeasure);
        return (aIndex<0?999:aIndex)-(bIndex<0?999:bIndex);
      }).map(function(input){return input.dataset.vvLabel||input.dataset.vvMeasure}).join(', ');
    }
    function exactLengthHelp(heading){
      return /PANTS|TROUSER|SKIRT/i.test(heading)?'Measure from the top of the waistband to the desired hem.':'Measure from the highest shoulder point to the desired hem.';
    }
    function helpMarkup(button){
      var heading=helpHeading(button);
      var text=button.dataset.vvHelpText||'';
      if(/BASE SIZE/i.test(heading))return '<p class="vv-eyebrow">BASE SIZE INFORMATION</p><h3>'+heading+'</h3><p>The base size gives our tailor the closest starting pattern. It does not determine the final fit by itself.</p><ul><li>Choose the size you normally wear in a similar garment.</li><li>Choose <strong>Other Size</strong> if your usual size is not listed or you are unsure.</li><li>Your body measurements are reviewed before the pattern is adjusted.</li></ul><p class="vv-help-measurements"><strong>Current selection:</strong> '+selectedHelpValue(button)+'<br><strong>Measurements entered next:</strong> '+nextMeasurementLabels()+'.</p>';
      if(/LENGTH/i.test(heading))return '<p class="vv-eyebrow">LENGTH INFORMATION</p><h3>'+heading+'</h3><ul><li><strong>Original Proportion:</strong> keeps the published silhouette and scales it from the selected base pattern.</li><li><strong>Slightly Shorter:</strong> makes a small proportional reduction while preserving the design.</li><li><strong>Slightly Longer:</strong> adds a small proportional amount while preserving the design.</li><li><strong>Exact Finished Length:</strong> lets you enter the exact finished measurement in the next step.</li></ul><p class="vv-help-measurements"><strong>Current selection:</strong> '+selectedHelpValue(button)+'<br><strong>If Exact is selected:</strong> '+exactLengthHelp(heading)+'</p>';
      return '<p class="vv-eyebrow">OPTION INFORMATION</p><h3>'+heading+'</h3><p>'+text+'</p>';
    }
    function positionHelp(button){
      var triggerRect=button.getBoundingClientRect();
      var panelRect=helpPopover.getBoundingClientRect();
      var left=Math.min(Math.max(12,triggerRect.left),window.innerWidth-panelRect.width-12);
      var top=triggerRect.bottom+8;
      if(top+panelRect.height>window.innerHeight-12)top=triggerRect.top-panelRect.height-8;
      helpPopover.style.left=left+'px';
      helpPopover.style.top=Math.max(12,top)+'px';
    }
    function closeHelp(restoreFocus){
      helpPopover.hidden=true;
      helpButtons.forEach(function(button){button.setAttribute('aria-expanded','false')});
      if(restoreFocus&&activeHelp)activeHelp.focus();
      activeHelp=null;
    }
    helpButtons.forEach(function(button){
      var helpText=button.getAttribute('title')||'';
      button.setAttribute('data-vv-help-text',helpText);
      button.removeAttribute('title');
      button.setAttribute('aria-label',helpText||'More information');
      button.setAttribute('aria-controls','vv-help-popover');
      button.setAttribute('aria-expanded','false');
      button.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        if(activeHelp===button&&!helpPopover.hidden){closeHelp();return}
        closeHelp();
        activeHelp=button;
        helpPopover.querySelector('[data-vv-help-content]').innerHTML=helpMarkup(button);
        helpPopover.hidden=false;
        helpPopover.id='vv-help-popover';
        button.setAttribute('aria-expanded','true');
        positionHelp(button);
      });
    });
    helpPopover.querySelector('.vv-help-popover-close').addEventListener('click',function(){closeHelp(true)});
    document.addEventListener('click',function(event){if(!helpPopover.hidden&&!helpPopover.contains(event.target))closeHelp()});
    document.addEventListener('keydown',function(event){if(event.key==='Escape'&&!helpPopover.hidden)closeHelp(true)});
    window.addEventListener('resize',function(){if(activeHelp&&!helpPopover.hidden)positionHelp(activeHelp)});
    var form=root.querySelector('.vv-product-form');
    var variants=JSON.parse(root.querySelector('[data-vv-variants]').textContent||'[]');
    var variantInput=root.querySelector('[data-vv-variant-id]');
    var price=root.querySelector('[data-vv-price]');
    var mobilePrice=root.querySelector('[data-vv-mobile-price]');
    var mobileSubmit=root.querySelector('[data-vv-mobile-submit]');
    var installment=root.querySelector('[data-vv-installment]');
    var colorNames=root.querySelectorAll('[data-vv-color-name]');
    var submit=root.querySelector('[data-vv-submit]');
    var topSizeProperty=root.querySelector('[data-vv-top-size-property]');
    var topOther=root.querySelector('[data-vv-top-other]');
    var progressItems=Array.prototype.slice.call(root.querySelectorAll('.vv-custom-progress li'));
    var customizationStarted=false;
    var measurementsConfirmed=false;
    var mobileAvailable=true;
    var accentColors={black:'#151515',white:'#555555',red:'#8f1722',pink:'#b85570',green:'#48633b','dark green':'#26382a','forest green':'#26382a','army green':'#4b5135',olive:'#60623b',blue:'#4c6d88',navy:'#202b43',brown:'#694536',caramel:'#9b6548',beige:'#8b704d',gray:'#666666',grey:'#666666',purple:'#745478',yellow:'#8a7118'};
    function colorFromKeywords(key){
      var names=Object.keys(accentColors).sort(function(a,b){return b.length-a.length});
      var match=names.find(function(name){return key.indexOf(name)>-1});
      return match?accentColors[match]:'';
    }
    function setProgress(step){
      progressItems.forEach(function(item,index){
        var number=index+1;
        var complete=number<step;
        var active=number===step;
        var marker=item.querySelector('span');
        item.classList.toggle('is-complete',complete);
        item.classList.toggle('is-active',active);
        if(active)item.setAttribute('aria-current','step');else item.removeAttribute('aria-current');
        if(marker)marker.textContent=complete?'✓':String(number);
      });
    }
    function syncAccentColor(){
      var selectedColor=root.querySelector('.vv-option-grid--color input:checked');
      var key=selectedColor?selectedColor.value.trim().toLowerCase():'';
      var configuredHex=selectedColor&&/^#[0-9a-f]{6}$/i.test(selectedColor.dataset.vvColorHex||'')?selectedColor.dataset.vvColorHex:'';
      root.style.setProperty('--vv-accent',configuredHex||accentColors[key]||colorFromKeywords(key)||'#7c242f');
      if(selectedColor)colorNames.forEach(function(colorName){colorName.textContent=selectedColor.dataset.vvColorDisplay||selectedColor.value;});
    }
    function syncTopSizeProperty(){
      if(!topSizeProperty)return;
      var fieldset=topSizeProperty.closest('fieldset');
      var selected=fieldset&&fieldset.querySelector('[data-option-index] input:checked, input[name^="vv-option-"]:checked');
      if(fieldset)fieldset.classList.toggle('is-other-size',!!(topOther&&topOther.checked));
      topSizeProperty.value=topOther&&topOther.checked?'Other size - determine from measurements':selected?selected.value:'';
    }
    function updateMobileAction(){
      if(!mobileSubmit)return;
      mobileSubmit.disabled=!mobileAvailable;
      if(!mobileAvailable){mobileSubmit.textContent='SOLD OUT';mobileSubmit.dataset.vvMobileStage='sold-out';return}
      if(measurementsConfirmed){mobileSubmit.textContent='ADD TO BAG';mobileSubmit.dataset.vvMobileStage='bag';return}
      if(customizationStarted){mobileSubmit.textContent='CONTINUE TO MEASUREMENTS';mobileSubmit.dataset.vvMobileStage='measure';return}
      mobileSubmit.textContent='START CUSTOMIZATION';mobileSubmit.dataset.vvMobileStage='start';
    }
    function beginCustomization(){customizationStarted=true;updateMobileAction()}
    function money(cents){return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify&&Shopify.currency&&Shopify.currency.active||'USD'}).format(cents/100)}
    function updateVariant(){
      syncAccentColor();
      var selected=[];
      root.querySelectorAll('[data-option-index]').forEach(function(group){var checked=group.querySelector('input:checked');selected.push(checked?checked.value:'')});
      var variant=variants.find(function(item){return item.options.every(function(value,index){return value===selected[index]})});
      if(!variant)return;
      variantInput.value=variant.id;
      if(price)price.textContent=money(variant.price);
      if(mobilePrice)mobilePrice.textContent=money(variant.price);
      if(installment)installment.textContent=money(variant.price/4);
      if(submit){submit.disabled=!variant.available;submit.textContent=variant.available?'CONTINUE TO MEASUREMENTS · '+money(variant.price):'SOLD OUT'}
      mobileAvailable=variant.available;updateMobileAction();
      syncTopSizeProperty();
    }
    root.querySelectorAll('[data-option-index] input').forEach(function(input){input.addEventListener('change',updateVariant)});
    updateVariant();
    setProgress(1);
    var modal=root.querySelector('[data-vv-measure-modal]');
    var sizeModal=root.querySelector('[data-vv-size-modal]');
    var viewportMeta=document.querySelector('meta[name="viewport"]');
    var viewportBeforeMeasure='';
    var viewportLockedForMeasure=false;
    var measurementInputs=Array.prototype.slice.call(modal.querySelectorAll('[data-vv-measure]'));
    var measurementUnit=(window.Shopify&&Shopify.country==='US')?'in':'cm';
    function numberText(value){return (Math.round(value*10)/10).toFixed(1)}
    function captureMeasurements(){
      measurementInputs.forEach(function(input){
        if(input.value===''){delete input.dataset.vvInches;return}
        var value=Number(input.value);
        if(Number.isFinite(value))input.dataset.vvInches=String(measurementUnit==='cm'?value/2.54:value);
      });
    }
    function syncOrderMeasurement(input){
      var key=input.dataset.vvMeasure;
      var order=modal.querySelector('[data-vv-order-measure="'+key+'"]');
      if(!order)return;
      var wrapper=input.closest('[data-vv-exact-field]');
      var usable=input.value!==''&&!(wrapper&&wrapper.hidden);
      order.disabled=!usable;
      order.value=usable?numberText(Number(input.value))+' '+measurementUnit:'';
    }
    function renderMeasurements(){
      var factor=measurementUnit==='cm'?2.54:1;
      measurementInputs.forEach(function(input){
        input.min=numberText(Number(input.dataset.minIn)*factor);
        input.max=numberText(Number(input.dataset.maxIn)*factor);
        if(input.dataset.vvInches)input.value=numberText(Number(input.dataset.vvInches)*factor);
        syncOrderMeasurement(input);
      });
      modal.querySelectorAll('[data-vv-unit-label]').forEach(function(label){label.textContent=measurementUnit});
      document.querySelectorAll('[data-vv-measure-unit],[data-vv-unit]').forEach(function(button){
        var unit=button.dataset.vvMeasureUnit||button.dataset.vvUnit;
        var active=unit===measurementUnit;
        button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',active?'true':'false');
      });
      var copy=modal.querySelector('[data-vv-unit-copy]');
      if(copy)copy.textContent='Enter measurements in '+(measurementUnit==='cm'?'centimetres':'inches')+'. Every order is reviewed before production.';
      var property=modal.querySelector('[data-vv-measure-unit-property]');
      if(property)property.value=measurementUnit.toUpperCase();
    }
    function setMeasurementUnit(unit){if(unit==='in'||unit==='cm'){captureMeasurements();measurementUnit=unit;renderMeasurements()}}
    measurementInputs.forEach(function(input){input.addEventListener('input',function(){
      if(input.value==='')delete input.dataset.vvInches;
      else input.dataset.vvInches=String(measurementUnit==='cm'?Number(input.value)/2.54:Number(input.value));
      syncOrderMeasurement(input);
    })});
    modal.querySelectorAll('[data-vv-measure-unit]').forEach(function(button){button.addEventListener('click',function(){setMeasurementUnit(button.dataset.vvMeasureUnit)})});
    function syncExactRequirements(){
      modal.querySelectorAll('[data-vv-exact-field]').forEach(function(field){
        var choice=form.querySelector('[name="properties['+field.dataset.vvExactFor+']"]:checked');
        var enabled=!!choice&&choice.value==='Exact finished length';
        var exact=field.querySelector('[data-vv-measure]');
        field.hidden=!enabled;exact.required=enabled;exact.disabled=!enabled;
        syncOrderMeasurement(exact);
      });
    }
    function lockMeasureViewport(){
      if(!viewportMeta||!window.matchMedia('(max-width: 760px)').matches||viewportLockedForMeasure)return;
      viewportBeforeMeasure=viewportMeta.getAttribute('content')||'width=device-width, initial-scale=1';
      viewportMeta.setAttribute('content','width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover');
      viewportLockedForMeasure=true;
    }
    function unlockMeasureViewport(){
      if(!viewportMeta||!viewportLockedForMeasure)return;
      viewportMeta.setAttribute('content',viewportBeforeMeasure);
      viewportLockedForMeasure=false;
    }
    function openModal(){syncExactRequirements();renderMeasurements();setProgress(2);lockMeasureViewport();modal.hidden=false;document.documentElement.style.overflow='hidden';document.body.style.overflow='hidden';var first=modal.querySelector('input[required]');if(first&&window.matchMedia('(min-width: 761px)').matches)first.focus()}
    function closeModal(){modal.hidden=true;document.documentElement.style.overflow='';document.body.style.overflow='';unlockMeasureViewport()}
    root.querySelectorAll('[data-vv-close]').forEach(function(button){button.addEventListener('click',closeModal)});
    function scrollToOptions(){
      var options=root.querySelector('[data-vv-options]');
      if(!options)return;
      var top=options.getBoundingClientRect().top+window.pageYOffset-16;
      window.scrollTo({top:Math.max(0,top),behavior:'smooth'});
    }
    root.querySelectorAll('[data-vv-scroll]').forEach(function(button){button.addEventListener('click',scrollToOptions)});
    root.querySelector('[data-vv-confirm]').addEventListener('click',function(){var required=modal.querySelectorAll('[required]');for(var i=0;i<required.length;i++){if(!required[i].reportValidity())return}measurementsConfirmed=true;updateMobileAction();setProgress(3);form.dataset.vvConfirmed='true';closeModal();if(form.requestSubmit)form.requestSubmit(submit);else submit.click();window.setTimeout(function(){delete form.dataset.vvConfirmed},1500)});
    var guideButton=root.querySelector('[data-vv-size-guide]');
    function closeSizeGuide(){sizeModal.hidden=true;document.documentElement.style.overflow=''}
    root.querySelectorAll('[data-vv-size-close]').forEach(function(button){button.addEventListener('click',closeSizeGuide)});
    sizeModal.querySelectorAll('[data-vv-unit]').forEach(function(button){button.addEventListener('click',function(){setMeasurementUnit(button.dataset.vvUnit)})});
    if(guideButton)guideButton.addEventListener('click',function(){sizeModal.hidden=false;document.documentElement.style.overflow='hidden'});
    var quoteModal=root.querySelector('[data-vv-quote-modal]');
    var quoteButton=root.querySelector('[data-vv-quote-open]');
    var quoteForm=root.querySelector('.vv-design-quote-form');
    function openQuote(){quoteModal.hidden=false;document.documentElement.style.overflow='hidden'}
    function closeQuote(){quoteModal.hidden=true;document.documentElement.style.overflow=''}
    root.querySelectorAll('[data-vv-quote-close]').forEach(function(button){button.addEventListener('click',closeQuote)});
    if(quoteButton)quoteButton.addEventListener('click',function(event){event.preventDefault();event.stopImmediatePropagation();openQuote()},true);
    if(quoteForm)quoteForm.addEventListener('submit',function(){
      var selected=Array.prototype.map.call(quoteForm.querySelectorAll('[data-vv-quote-type]:checked'),function(input){return input.value});
      var output=quoteForm.querySelector('[data-vv-quote-types]');
      if(output)output.value=selected.length?selected.join(', '):'Not specified';
    });
    if(root.querySelector('[data-vv-quote-success]'))openQuote();
    /* Shella can redraw product-form descendants after a variant change.
       Keep critical custom-made actions on the stable section root so they
       continue to work after color/size changes and on touch devices. */
    root.addEventListener('click',function(event){
      var action=event.target.closest('[data-vv-submit],[data-vv-mobile-submit],[data-vv-quote-open],[data-vv-size-guide],[data-vv-scroll]');
      if(!action||!root.contains(action))return;
      if(action.matches('[data-vv-submit],[data-vv-mobile-submit]')){
        if(action.matches('[data-vv-mobile-submit]')&&!customizationStarted){
          event.preventDefault();event.stopImmediatePropagation();beginCustomization();scrollToOptions();return;
        }
        var liveForm=root.querySelector('.vv-product-form');
        if(liveForm&&liveForm.dataset.vvConfirmed==='true')return;
        event.preventDefault();event.stopImmediatePropagation();
        form=liveForm||form;submit=action;openModal();
      }else if(action.matches('[data-vv-quote-open]')){
        event.preventDefault();event.stopImmediatePropagation();openQuote();
      }else if(action.matches('[data-vv-size-guide]')){
        event.preventDefault();event.stopImmediatePropagation();sizeModal.hidden=false;document.documentElement.style.overflow='hidden';
      }else if(action.matches('[data-vv-scroll]')){
        event.preventDefault();event.stopImmediatePropagation();beginCustomization();scrollToOptions();
      }
    },true);
    root.addEventListener('submit',function(event){
      var liveForm=event.target.closest('.vv-product-form');
      if(!liveForm||!root.contains(liveForm)||liveForm.dataset.vvConfirmed==='true')return;
      event.preventDefault();event.stopImmediatePropagation();
      form=liveForm;submit=liveForm.querySelector('[data-vv-submit]');openModal();
    },true);
    root.addEventListener('change',function(event){
      if(event.target.closest('.vv-product-form')&&event.target.matches('input,select'))beginCustomization();
      if(event.target.matches('[data-option-index] input')&&event.target!==topOther){
        if(topOther&&topSizeProperty&&topSizeProperty.closest('fieldset').contains(event.target))topOther.checked=false;
        updateVariant();
      }
      if(event.target.matches('[data-vv-top-other]'))syncTopSizeProperty();
    });
    [modal,sizeModal,quoteModal].forEach(function(panel){if(panel)document.body.appendChild(panel)});
    renderMeasurements();
  }
  function boot(){document.querySelectorAll('[data-vv-custom-product]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
